import React, { useEffect } from 'react';
import { useEditor } from '@craftjs/core';

export const SelectionHighlighter = ({ children }) => {
  const { selected, hovered } = useEditor((state) => ({
    selected: state.events.selected,
    hovered: state.events.hovered
  }));

  useEffect(() => {
    // Remove all previous highlights
    document.querySelectorAll('.craft-selected, .craft-hovered').forEach(el => {
      el.classList.remove('craft-selected', 'craft-hovered');
    });
    
    // Add selection highlight
    if (selected && selected.size > 0) {
      const selectedId = Array.from(selected)[0];
      const element = document.querySelector(`[data-node-id="${selectedId}"]`);
      if (element) {
        element.classList.add('craft-selected');
      }
    }
    
    // Add hover highlight (only if not selected)
    if (hovered && hovered.size > 0) {
      const hoveredId = Array.from(hovered)[0];
      const element = document.querySelector(`[data-node-id="${hoveredId}"]`);
      if (element && !selected?.has(hoveredId)) {
        element.classList.add('craft-hovered');
      }
    }
  }, [selected, hovered]);

  return <>{children}</>;
};